import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Input, Layout, Modal, Row, Select, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Const } from '../../common/constants/Constants';
import ColorServ from '../../services/ColorServ';
import Header from '../../common/compornents/layout/header/Header';
import HeaderRow2 from '../../common/compornents/layout/header/HeaderRow2';
import ColorSearchTable from '../../common/compornents/layout/table/ColorSearchTable';
import { Message } from '../../common/constants/Message';
import { generateMessage } from '../../common/util/MessageUtil';
import { notificationError, notificationInfo } from '../../common/compornents/notification';

const { Option } = Select;
const { Footer } = Layout;

// 見本板管理No.レイアウト
const formLabelLayout = {
  labelCol: {
    xxl: { span: 12, offset: 12 },
    xl: { span: 13, offset: 11 },
    lg: { span: 15, offset: 9 },
    md: { span: 20, offset: 5 },
    sm: { span: 24, offset: 5 },
    xs: { span: 24, offset: 3 },
  },
};

const formItemLayout = {
  wrapperCol: {
    xl: { span: 16, offset: 2 },
    lg: { span: 16, offset: 3 },
    md: { span: 17, offset: 3 },
    sm: { span: 17, offset: 3 },
    xs: { span: 16, offset: 8 },
  },
};

// 引数
interface IProps {
  // Modal表示用state
  visibleState: boolean;
  irogCd?: any;

  // 元画面判別
  yobidashimotoKbn?: any;

  // 関数
  closeColor: () => void;
  returnItem: (data: string[]) => void;
}

const ColorSearch: React.FC<IProps> = (props: IProps) => {
  // セッション情報
  const tokCd = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD) ?? '';
  const tokCd2 = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD2) ?? '';
  const companyName = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.COMPANY_NAME) ?? '';
  const manager = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TANTO_NAME) ?? '';

  const [form] = Form.useForm();
  const [readOnly, updateReadOnly] = useState<boolean>(false); // カタログの編集可否
  const [catalogList, setCatalogList] = useState<any[]>([]);
  const [colorList, setColorList] = useState<any[]>([]);
  const [rIdx, changeRowIndex] = useState(-1);
  const [dispValidMessage, changeDispValidMessage] = useState<boolean>(false); // 基本色調検索文字のエラーメッセージ表記
  const [dispFlg1, changeDispFlg1] = useState<boolean>(false);
  const [dispFlg2, changeDispFlg2] = useState<boolean>(false);
  const [dispFlg3, changeDispFlg3] = useState<boolean>(false);

  // 初期化処理
  useEffect(() => {
    const init = async () => {
      // カタログ情報を検索するAPIを呼び出しDBから値を取得
      ColorServ.getCatalogData()
        .then((json) => {
          setCatalogList(() => json.data);
          // カタログの初期値を「props.カタログ」にし、
          // 遷移元画面が受注照会だったらカタログの初期値を「過去色」にし、編集不可にする
          if (props.yobidashimotoKbn === '2') {
            updateReadOnly(true); //カタログの編集を不可にする
            form.setFieldsValue({
              irogCd: 'ZZZZZ',
            });
          } else {
            form.setFieldsValue({
              irogCd: json.data[0]['irogCd'],
            });
            for (let i = 0; i < json.data.length; i++) {
              if (json.data[i]['irogCd'] === props.irogCd) {
                form.setFieldsValue({
                  irogCd: props.irogCd,
                });
              }
            }
          }
        })
        .catch((error: any) => {
          notificationError(
            '色検索',
            generateMessage(Message.ERROR_MASSAGE.ERR999, 'カタログ検索')
          );
        });
    };
    if (props.visibleState) {
      form.resetFields();
      setColorList(() => []);
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visibleState]);

  // 検索処理
  const dataSearch = () => {
    form.validateFields().then(() => {
      let data = form.getFieldsValue();

      // 画面で入力された条件
      var irogCd = data.irogCd || '';
      var hyoujiIroCd1 = data.hyoujiIroCd1 || '';
      var hyoujiIroCd2 = data.hyoujiIroCd2 || '';
      var hyoujiIroCd3 = data.hyoujiIroCd3 || '';
      var kihonIroCd1 = data.kihonIroCd1 || '';
      var kihonIroCd2 = data.kihonIroCd2 || '';
      var kihonIroCd3 = data.kihonIroCd3 || '';
      var hinNm1 = data.hinNm1 || '';
      var hinNm2 = data.hinNm2 || '';
      var hinNm3 = data.hinNm3 || '';
      var genbutuNo = data.genbutuNo || '';
      var mihonNo = data.mihonNo || '';

      // APIに渡すパラメーターを設定
      var params = {
        tokCd,
        tokCd2,
        irogCd,
        hyoujiIroCd1,
        hyoujiIroCd2,
        hyoujiIroCd3,
        kihonIroCd1,
        kihonIroCd2,
        kihonIroCd3,
        hinNm1,
        hinNm2,
        hinNm3,
        genbutuNo,
        mihonNo,
      };

      // APIを呼び出しDBから値を取得
      ColorServ.getColorData(params)
        .then((json) => {
          if (json.data.length >= 1000) {
            notificationInfo('色検索', generateMessage(Message.INFO_MASSAGE.INF010));
          }
          setColorList(() => json.data);
        })
        .catch((error) => {
          notificationError('色検索', generateMessage(Message.ERROR_MASSAGE.ERR999, '色検索'));
        });
    });
  };

  // クリア処理
  const dataClear = () => {
    form.resetFields();
    changeDispValidMessage(false);
    changeDispFlg1(false);
    changeDispFlg2(false);
    changeDispFlg3(false);
    setColorList(() => []);
    if (props.yobidashimotoKbn === '2') {
      form.setFieldsValue({
        irogCd: 'ZZZZZ',
      });
    } else {
      form.setFieldsValue({
        irogCd: catalogList[0]['irogCd'],
      });
      for (let i = 0; i < catalogList.length; i++) {
        if (catalogList[i]['irogCd'] === props.irogCd) {
          form.setFieldsValue({
            irogCd: props.irogCd,
          });
        }
      }
    }
  };

  // 行選択
  useEffect(() => {
    if (rIdx >= 0) {
      // 配列に格納
      var vals = [];
      vals.push(colorList[rIdx].irogCd);
      vals.push(colorList[rIdx].irogNm);
      vals.push(colorList[rIdx].hyoujiIroCd);
      vals.push(colorList[rIdx].kihonIroCd);
      vals.push(colorList[rIdx].genbutuNo);
      vals.push(colorList[rIdx].mihonNo);
      props.returnItem(vals);
      dataClear();
      changeRowIndex(-1);
      props.closeColor();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rIdx]);

  //閉じるボタン押下
  function winClose() {
    dataClear();
    props.closeColor();
  }

  // メッセージ表記関数
  const dispMessage = (e: any, nyuryokuKbn: number) => {
    let value = e.target.value.split('');
    let msgFlg = 0;
    const reg = /[^a-zA-Z0-9]+$/;
    for (let i = 0; i < value.length; i++) {
      // テキストボックスの値を１文字ずつテスト
      if (reg.test(value[i])) {
        if (nyuryokuKbn === 1) {
          changeDispValidMessage(true);
          changeDispFlg1(true);
        } else if (nyuryokuKbn === 2) {
          if (!dispFlg1) {
            changeDispValidMessage(true);
          }
          changeDispFlg2(true);
        } else {
          if (!dispFlg1) {
            if (!dispFlg2) {
              changeDispValidMessage(true);
            }
          }
          changeDispFlg3(true);
        }
        // 半角英数字じゃない値があれば処理を抜け出す
        msgFlg = 1;
        break;
      }
    }
    // 全て半角であれば状況に応じてバリデーション表示を決定
    if (msgFlg === 0) {
      if (nyuryokuKbn === 1) {
        changeDispFlg1(false);
        if (!dispFlg2) {
          if (!dispFlg3) {
            changeDispValidMessage(false);
          }
        }
      } else if (nyuryokuKbn === 2) {
        changeDispFlg2(false);
        if (!dispFlg1) {
          if (!dispFlg3) {
            changeDispValidMessage(false);
          }
        }
      } else {
        changeDispFlg3(false);
        if (!dispFlg1) {
          if (!dispFlg2) {
            changeDispValidMessage(false);
          }
        }
      }
    }
    form.validateFields();
  };

  const checkValid = (_: any) => {
    if (dispValidMessage === true) {
      return Promise.reject(new Error(generateMessage(Message.ERROR_MASSAGE.ERR017, '基本色調')));
    }
    return Promise.resolve();
  };

  return (
    <>
      <Modal closable={false} width={1300} visible={props.visibleState} footer={null}>
        <Header screenName={'色検索'} />
        <Form
          form={form}
          layout="horizontal"
          autoComplete="off"
          style={{ backgroundColor: '#e6f7ff' }}
        >
          {/* ヘッダ情報（ログインID */}
          <HeaderRow2 compnyNm={companyName} accNm={manager} />

          {/* カタログ */}
          <Row style={{ paddingTop: '1vh' }}>
            <Col
              xs={{ span: 8, offset: 1 }}
              sm={{ span: 6, offset: 1 }}
              lg={{ span: 4, offset: 1 }}
              xl={{ span: 3, offset: 2 }}
            >
              <Form.Item label="カタログ"></Form.Item>
            </Col>
            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <Form.Item name={'irogCd'}>
                <Select
                  style={
                    readOnly
                      ? { pointerEvents: 'none', minWidth: '100px', width: '100%' }
                      : { minWidth: '100px', width: '100%' }
                  }
                  notFoundContent=" "
                >
                  {catalogList.length > 0 &&
                    catalogList.map((item, i) => {
                      return (
                        <Option key={i} value={item.irogCd}>
                          {item.irogNm}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {/* 表示色調検索文字 */}
          <Row>
            <Col
              xs={{ span: 8, offset: 1 }}
              sm={{ span: 6, offset: 1 }}
              lg={{ span: 4, offset: 1 }}
              xl={{ span: 3, offset: 2 }}
            >
              <Form.Item label="表示色調検索文字"></Form.Item>
            </Col>
            <Col lg={4} sm={5} xs={4}>
              <Form.Item name={'hyoujiIroCd1'}>
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col lg={4} sm={5} xs={4}>
              <Form.Item name={'hyoujiIroCd2'}>
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col lg={4} sm={5} xs={4}>
              <Form.Item name={'hyoujiIroCd3'}>
                <Input maxLength={10} />
              </Form.Item>
            </Col>
          </Row>

          {/* 基本色調検索文字 */}
          <Row>
            <Col
              xs={{ span: 8, offset: 1 }}
              sm={{ span: 6, offset: 1 }}
              lg={{ span: 4, offset: 1 }}
              xl={{ span: 3, offset: 2 }}
            >
              <Form.Item label="基本色調検索文字"></Form.Item>
            </Col>
            <Col lg={4} sm={5} xs={4}>
              <Form.Item name={'kihonIroCd1'} rules={[{ validator: checkValid }]}>
                <Input maxLength={10} onChange={(e) => dispMessage(e, 1)} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col lg={4} sm={5} xs={4}>
              <Form.Item name={'kihonIroCd2'}>
                <Input maxLength={10} onChange={(e) => dispMessage(e, 2)} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col lg={4} sm={5} xs={4}>
              <Form.Item name={'kihonIroCd3'}>
                <Input maxLength={10} onChange={(e) => dispMessage(e, 3)} />
              </Form.Item>
            </Col>
          </Row>

          {/* 製品名検索文字 */}
          <Row>
            <Col
              xs={{ span: 8, offset: 1 }}
              sm={{ span: 6, offset: 1 }}
              lg={{ span: 4, offset: 1 }}
              xl={{ span: 3, offset: 2 }}
            >
              <Form.Item label="製品名検索文字"></Form.Item>
            </Col>
            <Col lg={4} sm={5} xs={4}>
              <Form.Item name={'hinNm1'}>
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col lg={4} sm={5} xs={4}>
              <Form.Item name={'hinNm2'}>
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col lg={4} sm={5} xs={4}>
              <Form.Item name={'hinNm3'}>
                <Input maxLength={10} />
              </Form.Item>
            </Col>
          </Row>

          {/* 現物管理No. */}
          <Row>
            <Col
              xs={{ span: 8, offset: 1 }}
              sm={{ span: 6, offset: 1 }}
              lg={{ span: 4, offset: 1 }}
              xl={{ span: 3, offset: 2 }}
            >
              <Form.Item label="現物管理No."></Form.Item>
            </Col>
            <Col lg={4} sm={5} xs={4}>
              <Form.Item
                name={'genbutuNo'}
                rules={[
                  {
                    pattern: /^[a-zA-Z0-9]+$/,
                    message: generateMessage(Message.ERROR_MASSAGE.ERR017, '現物管理No.'),
                  },
                ]}
              >
                <Input maxLength={10} />
              </Form.Item>
            </Col>

            {/* 見本板管理No. */}
            <Col lg={4} sm={5} xs={4}>
              <Form.Item {...formLabelLayout} label="見本板管理No."></Form.Item>
            </Col>
            <Col lg={6} sm={7} xs={4}>
              <Form.Item
                {...formItemLayout}
                name={'mihonNo'}
                style={{ position: 'relative', right: 3 }}
                rules={[
                  {
                    pattern: /^[a-zA-Z0-9]+$/,
                    message: generateMessage(Message.ERROR_MASSAGE.ERR017, '見本板管理No.'),
                  },
                ]}
              >
                <Input maxLength={10} />
              </Form.Item>
            </Col>

            {/* 検索ボタンとクリアボタン */}
            <Col lg={{ offset: 0 }} md={{ offset: 17 }} sm={{ offset: 15 }} xs={{ offset: 14 }}>
              <Space size={'large'}>
                <Button type="primary" onClick={dataSearch}>
                  <SearchOutlined />
                  検索
                </Button>
                <Button type="primary" onClick={dataClear}>
                  クリア
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>

        {/* テーブル */}
        <Row style={{ paddingTop: '2vh', backgroundColor: '#e6f7ff' }}>
          <Col offset={1} xs={22}>
            <ColorSearchTable
              dataColor={colorList}
              rowIndex={rIdx}
              changeRowIndex={changeRowIndex}
            />
          </Col>
        </Row>

        {/* 閉じるボタン */}
        <Footer
          style={{
            backgroundColor: '#e6f7ff',
            height: '70px',
          }}
        >
          <Row justify="end">
            <Col>
              <Button type="primary" onClick={winClose}>
                閉じる
              </Button>
            </Col>
          </Row>
        </Footer>
      </Modal>
    </>
  );
};

export default ColorSearch;
